const PO_HARD_DELETE_ROLES = [
  "platform_owner",
  "platform_admin",
  "platform_dev",
  "dev",
  "manufacturing_purchasing",
  "manufacturing",
] as const;

/** Permanent PO delete — platform developers (matches the server gate plus org `dev`). */
export function canHardDeleteManufacturingPurchaseOrder(
  hasRole: (...roles: string[]) => boolean
): boolean {
  return hasRole(...PO_HARD_DELETE_ROLES);
}
